import type {
  SubscriptionPlanCatalogFromAPI,
  SubscriptionPlanFromAPI,
} from '../types/subscription';

function isSubscriptionPlan(value: unknown): value is SubscriptionPlanFromAPI {
  if (!value || typeof value !== 'object') return false;
  const plan = value as Record<string, unknown>;
  return (
    typeof plan.id === 'string' &&
    typeof plan.name === 'string' &&
    typeof plan.code === 'string' &&
    typeof plan.price === 'number' &&
    typeof plan.cycle === 'string' &&
    Array.isArray(plan.features) &&
    typeof plan.popular === 'boolean' &&
    typeof plan.sortOrder === 'number'
  );
}

/**
 * Valida o envelope `{ trialDays, plans }` de GET /subscription-plan (FLOW-113).
 */
export function parseSubscriptionPlanCatalog(data: unknown): SubscriptionPlanCatalogFromAPI {
  if (!data || typeof data !== 'object') {
    throw new Error('Resposta de planos inválida');
  }

  const body = data as Record<string, unknown>;
  const trialDays = body.trialDays;
  if (typeof trialDays !== 'number' || !Number.isFinite(trialDays) || trialDays < 1) {
    throw new Error('Resposta de planos sem trialDays válido');
  }

  if (!Array.isArray(body.plans)) {
    throw new Error('Resposta de planos sem lista de planos');
  }

  if (!body.plans.every(isSubscriptionPlan)) {
    throw new Error('Resposta de planos com item inválido');
  }

  return {
    trialDays,
    plans: body.plans,
  };
}
